import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";
import "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDtTMUOyzLGdfd1ecAbuttKz9H12qROO_g",
  authDomain: "phototab-23cd2.firebaseapp.com",
  databaseURL: "https://phototab-23cd2.firebaseio.com",
  projectId: "phototab-23cd2",
  storageBucket: "phototab-23cd2.appspot.com",
  messagingSenderId: "65680087374",
  appId: "1:65680087374:web:4a379ca583af1358cf661f",
};

firebase.initializeApp(firebaseConfig);
const storage = firebase.storage();
const firestore = firebase.firestore();
const auth = firebase.auth();
const timestamp = firebase.firestore.FieldValue.serverTimestamp;

export { storage, firestore, auth, timestamp };
